<template>
  <div class="p-page-wrapper">
    <template v-if="!currentProjectId">
      <v-row>
        <v-col>
          <p-no-data
            :text="$t('noProjects')"
            :hide-btn="true"
            img="member.png"
            class="p-no-data-mt"
          ></p-no-data>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <div class="p-toolbar">
        <div class="p-toolbar-item p-search">
          <p-search-input
            v-model="search"
            :items="searchSuggestions"
          ></p-search-input>
        </div>
        <div v-if="hasAccess()" class="p-toolbar-item p-right">
          <v-btn
            class="p-btn-rounded ml-4"
            large
            rounded
            @click.stop="openEditDialog(null)"
          >
            {{ $t('member.addMember') }}
          </v-btn>
        </div>
      </div>
      <v-row>
        <v-col>
          <v-data-table
            :headers="tableHeaders"
            :items="tableRows"
            :search="search"
            no-data-text=""
            class="p-no-borders"
            hide-default-footer
            disable-pagination
            @page-count="pageCount = $event"
          >
            <template v-slot:[`item.contact`]="{ item }">
              <p-contact-item
                :contact="item.contact"
                class="px-0"
                font-bold
              ></p-contact-item>
            </template>
            <template v-slot:[`item.changed`]="{ item }">
              <v-tooltip v-if="item.changed" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <span v-if="item.changed" class="item-changed"></span>
                  </v-btn>
                </template>
                {{ $t('member.table.changedTooltip') }}
              </v-tooltip>
            </template>
            <template v-slot:[`item.function`]="{ item }">
              <v-edit-dialog
                :return-value.sync="inlineEditMember.function"
                @open="inlineEditOpen(item)"
                @save="inlineEditSave(false)"
              >
                {{ item.function }}
                <template v-slot:input>
                  <v-text-field
                    v-model="inlineEditMember.function"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <template v-if="hasAccess()" v-slot:[`item.travelCost`]="{ item }">
              <v-edit-dialog
                :return-value.sync="inlineEditMember.travelCost"
                @open="inlineEditOpen(item)"
                @save="inlineEditSave(true)"
              >
                <p-currency :value="item.travelCost"></p-currency>
                <template v-slot:input>
                  <v-text-field
                    v-model="inlineEditMember.travelCost"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <p-currency v-else :value="item.travelCost"></p-currency>

            <template v-if="hasAccess()" v-slot:[`item.dietDays`]="{ item }">
              <v-edit-dialog
                :return-value.sync="inlineEditMember.dietDays"
                @open="inlineEditOpen(item)"
                @save="inlineEditSave(true)"
              >
                {{ item.dietDays }}
                <template v-slot:input>
                  <v-text-field
                    v-model="inlineEditMember.dietDays"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <template v-else>{{ item.dietDays }}</template>

            <template v-if="hasAccess()" v-slot:[`item.dietPerDay`]="{ item }">
              <v-edit-dialog
                :return-value.sync="inlineEditMember.dietPerDay"
                @open="inlineEditOpen(item)"
                @save="inlineEditSave(true)"
              >
                <p-currency :value="item.dietPerDay"></p-currency>
                <template v-slot:input>
                  <v-text-field
                    v-model="inlineEditMember.dietPerDay"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <p-currency v-else :value="item.dietPerDay"></p-currency>

            <template v-slot:[`item.totalDiet`]="{ item }">
              <p-currency :value="item.totalDiet"></p-currency>
            </template>

            <template v-if="hasAccess()" v-slot:[`item.hotelDays`]="{ item }">
              <v-edit-dialog
                :return-value.sync="inlineEditMember.hotelDays"
                @open="inlineEditOpen(item)"
                @save="inlineEditSave(true)"
              >
                {{ item.hotelDays }}
                <template v-slot:input>
                  <v-text-field
                    v-model="inlineEditMember.hotelDays"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <template v-else>{{ item.hotelDays }}</template>

            <template v-if="hasAccess()" v-slot:[`item.hotelPerDay`]="{ item }">
              <v-edit-dialog
                :return-value.sync="inlineEditMember.hotelPerDay"
                @open="inlineEditOpen(item)"
                @save="inlineEditSave(true)"
              >
                <p-currency :value="item.hotelPerDay"></p-currency>
                <template v-slot:input>
                  <v-text-field
                    v-model="inlineEditMember.hotelPerDay"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <p-currency v-else :value="item.hotelPerDay"></p-currency>

            <template v-slot:[`item.totalHotels`]="{ item }">
              <p-currency :value="item.totalHotels"></p-currency>
            </template>

            <template v-if="hasAccess()" v-slot:[`item.otherCost`]="{ item }">
              <v-edit-dialog
                :return-value.sync="inlineEditMember.otherCost"
                @open="inlineEditOpen(item)"
                @save="inlineEditSave(true)"
              >
                <p-currency :value="item.otherCost"></p-currency>
                <template v-slot:input>
                  <v-text-field
                    v-model="inlineEditMember.otherCost"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <p-currency v-else :value="item.otherCost"></p-currency>

            <template v-if="hasAccess()" v-slot:[`item.wage`]="{ item }">
              <v-edit-dialog
                :return-value.sync="inlineEditMember.wage"
                @open="inlineEditOpen(item)"
                @save="inlineEditSave(true)"
              >
                <p-currency :value="item.wage"></p-currency>
                <template v-slot:input>
                  <v-text-field
                    v-model="inlineEditMember.wage"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <p-currency v-else :value="item.wage"></p-currency>

            <template v-slot:[`item.totalCost`]="{ item }">
              <p-currency :value="item.totalCost"></p-currency>
            </template>
            <template v-if="hasAccess()" v-slot:[`item.actions`]="{ item }">
              <div class="p-table-row-actions p-visible-on-row-hover">
                <p-btn-icon type="edit" @click="openEditDialog(item)"></p-btn-icon>
                <p-btn-icon type="copy" @click="openCopyDialog(item)"></p-btn-icon>
                <p-btn-icon type="delete" @click="deleteMember_(item)"></p-btn-icon>
              </div>
            </template>
            <template v-slot:footer>
              <v-autocomplete
                ref="addMemberInput"
                v-if="members.length && addMemberSuggestions.length && hasAccess()"
                v-model="addMemberContactId"
                :search-input.sync="addMemberSearch"
                :items="addMemberSuggestions"
                :placeholder="$t('member.addMember')"
                :disabled="addMemberInputDisabled"
                :menu-props="{ value: addMemberInputMenu }"
                item-value="id"
                item-text="displayNameWithCompany"
                class="p-input-solo-filled mt-5"
                auto-select-first
                solo
                clearable
                @change="addMemberInputMenu = false"
                @keyup="onAddMemberInputKeyup"
                @blur="onAddMemberInputBlur"
              >
                <template v-slot:append>
                  <v-btn icon @click.stop="addMember">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
              </v-autocomplete>
            </template>
            <template v-slot:[`no-data`]>
              <p-no-data
                v-if="!membersLoading && currentProjectId"
                :text="$t('member.noMembers')"
                :btn-text="$t('member.addMember')"
                :hide-btn="!hasAccess()"
                img="member.png"
                class="p-no-data-mt"
                @btn-click="openEditDialog(null)"
              ></p-no-data>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </template>
    <member-edit-dialog
      :dialog.sync="editDialog"
      :member="editMember"
    ></member-edit-dialog>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'

import PContactItem from '@/components/PContactItem'
import PSearchInput from '@/components/PSearchInput'
import PNoData from '@/components/PNoData'
import PBtnIcon from '@/components/PBtnIcon'
import PCurrency from '@/components/PCurrency'

import MemberEditDialog from './MemberEditDialog'

import snackbarMixin from '@/mixins/snackbar.mixin'
import pageMixin from '@/mixins/page.mixin'
import objectMixin from '@/mixins/object.mixin'
import accessMixin from '@/mixins/access.mixin'

import eventBus from '@/eventBus'

export default {
  components: {
    PContactItem,
    PSearchInput,
    PNoData,
    PBtnIcon,
    PCurrency,
    MemberEditDialog
  },


  mixins: [
    snackbarMixin,
    pageMixin,
    objectMixin,
    accessMixin
  ],


  data () {
    return {
      search: '',
      editDialog: false,
      editMember: null,
      inlineEditMember: {},
      membersLoading: true,
      addMemberContactId: null,
      addMemberSearch: '',
      addMemberInputDisabled: false,
      addMemberInputMenu: false
    }
  },


  computed: {
    ...mapGetters('contact', ['shortContactById', 'shortContacts']),
    ...mapGetters('member', ['membersByProject']),
    ...mapGetters('project', ['currentProjectId']),
    ...mapGetters('settings', ['currentSettings']),
    ...mapGetters('changes', ['isItemChanged']),

    tableRows () {
      return this.members.map(item => {
        return {
          ...item,
          changed: this.isItemChanged(item.id)
        }
      })
    },

    tableHeaders () {
      return [
        { text: this.$t('member.table.contact'), value: 'contact.displayNameWithCompany' },
        { text: '', value: 'changed' },
        { text: this.$t('member.table.function'), value: 'function' },
        { text: this.$t('member.table.travelCost'), value: 'travelCost', align: 'end', filterable: false },
        { text: this.$t('member.table.dietDays'), value: 'dietDays', align: 'end', filterable: false },
        { text: this.$t('member.table.dietPerDay'), value: 'dietPerDay', align: 'end', filterable: false },
        { text: this.$t('member.table.totalDiet'), value: 'totalDiet', align: 'end', filterable: false },
        { text: this.$t('member.table.hotelDays'), value: 'hotelDays', align: 'end', filterable: false },
        { text: this.$t('member.table.hotelPerDay'), value: 'hotelPerDay', align: 'end', filterable: false },
        { text: this.$t('member.table.totalHotels'), value: 'totalHotels', align: 'end', filterable: false },
        { text: this.$t('member.table.otherCost'), value: 'otherCost', align: 'end', filterable: false },
        { text: this.$t('member.table.wage'), value: 'wage', align: 'end', filterable: false },
        { text: this.$t('member.table.totalCost'), value: 'totalCost', align: 'end', filterable: false },
        { text: '', value: 'actions', align: 'end', sortable: false, filterable: false }
      ]
    },

    searchSuggestions () {
      return this.members.map(member => {
        return member.contact.displayNameWithCompany
      })
    },

    members () {
      const members = this.membersByProject(this.currentProjectId).map(member => {
        if (!member.contactId) {
          member.contact.displayNameWithCompany = member.name
        }
        return member
      })
      return members
    },

    addMemberSuggestions () {
      return this.shortContacts.filter(contact => !this.members.find(member => member.contactId === contact.id))
    }
  },


  watch: {
    currentProjectId () {
      if (!this.currentProjectId) return false
      this.membersLoading = true
      this.startPageLoading()
      this.loadMembersByProject(this.currentProjectId).then(() => {
        this.membersLoading = false
        this.stopPageLoading()
      })
    }
  },


  methods: {
    ...mapActions('member', ['loadMembersByProject', 'deleteMember', 'createMember', 'updateMember']),
    ...mapActions('contact', ['loadShortContacts']),

    initEventBus () {
      eventBus.$on('goToEntity', (entityTitle) => {
        this.search = entityTitle
      })
    },

    openEditDialog (member) {
      this.editMember = member
      this.editDialog = true
    },

    openCopyDialog (member) {
      this.editMember = { ...member }
      delete this.editMember.contact
      delete this.editMember.contactId

      this.editDialog = true
    },

    async onAddMemberInputKeyup (event) {
      if (event.keyCode === 13 /* Enter */) {
        await this.addMember()
      } else if (event.keyCode === 27 /* Esc */) {
        this.addMemberInputMenu = false
        this.addMemberSearch = ''
      } else {
        this.addMemberInputMenu = !!this.addMemberSearch
      }
    },

    onAddMemberInputBlur () {
      this.addMemberInputMenu = false
      this.addMemberSearch = ''
    },

    async addMember () {
      try {
        if (this.addMemberContactId) {
          this.addMemberInputMenu = false
          this.addMemberInputDisabled = true
          const member = {
            contactId: this.addMemberContactId,
            projectId: this.currentProjectId,
            function: '',
            travelCost: 0,
            dietDays: 0,
            dietPerDay: this.currentSettings.diet ?? 0,
            hotelDays: 0,
            hotelPerDay: this.currentSettings.hotel ?? 0,
            otherCost: 0,
            wage: 0,
            totalCost: 0
          }

          await this.createMember(member)

          this.addMemberContactId = null
          this.addMemberInputDisabled = false
          this.$nextTick(() => this.$refs.addMemberInput.focus())
        }
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    },

    async deleteMember_ (member) {
      try {
        const confirm = await this.$confirm(this.$t('member.deleteMemberConfirm', { name: member.contact.displayNameWithCompany }), { trueText: this.$t('delete') })
        if (confirm === true) {
          this.showSnackbarProcessing()
          await this.deleteMember(member)
          this.showSnackbarSuccess(this.$t('member.memberDeleted'))
        }
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    },

    inlineEditOpen (member) {
      this.inlineEditMember = this.getObjectCopy(member)
    },

    async inlineEditSave (emitChange) {
      try {
        await this.updateMember(this.inlineEditMember)
        if (emitChange) {
          this.$emit('change')
        }
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    }
  },

  async created () {
    this.initEventBus()
    this.setPageTitle(this.$t('nav.members'))
    if (!this.currentProjectId) return false
    try {
      this.startPageLoading()
      await Promise.all([
        this.loadShortContacts(),
        this.loadMembersByProject(this.currentProjectId)
      ])
      this.membersLoading = false
      if (this.$router.currentRoute.params?.goto) {
        this.search = this.$router.currentRoute.params?.goto
      }
    } catch (error) {
      this.showSnackbarError()
      this.$log.error(error)
    } finally {
      this.stopPageLoading()
    }
  }
}
</script>
